// extracted by mini-css-extract-plugin
export default {"group":"styles_group__lT3p7"};